import {useState, Fragment, useEffect} from 'react'
import DataTable from 'react-data-table-component'
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Spinner
} from 'reactstrap'
import {useSelector, useDispatch} from 'react-redux'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import CustomPagination from '@src/views/components/pagination/CustomPagination'
import AdminFilters from "../../components/AdminFilters"
import {
    adminSubsBrands
} from "@src/redux/actions/AdminActions"
import moment from "moment/moment";
import queryString from "query-string"
import {Link} from "react-router-dom";

const SubscribedBrands = () => {
    const dispatch = useDispatch()

    const [filtersData, setFiltersData] = useState(null)

    const {
        adminSubsBrandLoading,
        adminSubsBrandData,
        adminSubsBrandError
    } = useSelector(store => store.adminReducer)

    useEffect(() => {
        dispatch(adminSubsBrands({}))
    }, [])

    const searchData = (data) => {
        setFiltersData(data)
        const {
            companyName, brandOwnerName, subscriptionPlan, date
        } = data
        dispatch(adminSubsBrands({
            brand_name: companyName,
            owner_name: brandOwnerName,
            plan_id: subscriptionPlan ? subscriptionPlan.value : '',
            purchase_from: date ? moment(date[0]).format('YYYY-MM-DD') : '',
            purchase_to: date ? moment(date[1]).format('YYYY-MM-DD') : '',
        }))
    }

    const handleCustomPagination = (pageURL) => {
        const parsed = queryString.parseUrl(pageURL);
        let obj = {
            page: parsed?.query?.page
        }
        if (filtersData) {
            const {
                companyName, brandOwnerName, subscriptionPlan, date
            } = filtersData
            obj = {
                ...obj,
                brand_name: companyName,
                owner_name: brandOwnerName,
                plan_id: subscriptionPlan ? subscriptionPlan.value : '',
                purchase_from: date ? moment(date[0]).format('YYYY-MM-DD') : '',
                purchase_to: date ? moment(date[1]).format('YYYY-MM-DD') : '',
            }
        }
        dispatch(adminSubsBrands(obj))
    }

    const advSearchColumns = [
        {
            name: 'company',
            selector: 'company',
            sortable: true,
            cell: row => {
                return (
                    <Link to={`/admin/manage-brands/${row?.id}`} className='font-weight-bold'>{row?.company}</Link>
                )
            }
        },
        {
            name: 'contact name',
            selector: 'contact_name',
            sortable: true
        },
        {
            name: 'purchased date',
            selector: 'purchased_date',
            sortable: true
        },
        {
            name: 'expire date',
            selector: 'expiry_date',
            sortable: true
        },
        {
            name: 'subscription plan',
            selector: 'subscription_type',
            sortable: true,
            cell: row => <span>{row.subscription_type ?? "-"}</span>
        },
        {
            name: 'Payment Status',
            selector: 'status',
            sortable: true,
            cell: row => <span className={row.status === 'Refunded' ? 'text-danger' : ''}>{row.status}</span>
        },
        {
            name: 'Total paid',
            selector: 'total_paid',
            sortable: true,
            cell: row => <span className='badge badge-primary'>${row.total_paid}</span>
        }
    ]

    return (
        <Fragment>
            <Card>
                <CardHeader className='border-bottom'>
                    <CardTitle tag='h4'>Subscribed Brands</CardTitle>
                </CardHeader>
                <CardBody>
                    <AdminFilters
                        role='brand'
                        onSubmit={(data) => searchData(data)}
                        onClear={() => {
                            dispatch(adminSubsBrands({}))
                            setFiltersData(null)
                        }}
                    />
                    {adminSubsBrandLoading ? <div className="w-100 my-4 text-center"><Spinner color='primary'/></div> :
                        <DataTable noHeader={true}
                                   columns={advSearchColumns}
                                   className='react-dataTable'
                                   data={adminSubsBrandData?.data}
                        />
                    }
                    <CustomPagination
                        pageLinks={adminSubsBrandData?.pages}
                        onPaginationClick={handleCustomPagination}
                    />
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default SubscribedBrands